"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, type ReactNode } from "react";
import type { Dictionary } from "@/dictionaries/types";
import type { Collection } from "@/features/collections/types";
import type { DetailModel } from "../model";
import VitrineActions from "./VitrineActions";

/*
 * WHERE THE ACTIONS LIVE — twice, from one source. On the cover, as the
 * chrome's glass label; and, once the cover has scrolled away and the chapter
 * bar has pinned, a compact copy at the bar's end, so like / watch / share stay
 * within reach deep in the works (CSS shows it only on `.vt-nav[data-stuck]`).
 * The hero is a server component, so the data reaches both slots through
 * this context rather than props.
 */

type Ctx = {
  collection: Collection;
  m: DetailModel;
  t: Dictionary["collectionPage"];
  isFa: boolean;
};
const ActionsContext = createContext<Ctx | null>(null);
export function ActionsSlot(t0) {
  const $ = _c(9);
  const {
    at
  } = t0;
  const ctx = useContext(ActionsContext);
  if (!ctx) {
    return null;
  }
  let t1;
  if ($[0] !== at || $[1] !== ctx.collection || $[2] !== ctx.isFa || $[3] !== ctx.m || $[4] !== ctx.t) {
    t1 = <VitrineActions collection={ctx.collection} m={ctx.m} t={ctx.t} isFa={ctx.isFa} look={at} />;
    $[0] = at;
    $[1] = ctx.collection;
    $[2] = ctx.isFa;
    $[3] = ctx.m;
    $[4] = ctx.t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== at || $[7] !== t1) {
    t2 = <div className="vt-slot" data-at={at}>{t1}</div>;
    $[6] = at;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
export default function ActionsPlacement(t0) {
  const $ = _c(8);
  let children;
  let ctx;
  if ($[0] !== t0) {
    ({
      children,
      ...ctx
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = ctx;
  } else {
    children = $[1];
    ctx = $[2];
  }
  let t1;
  if ($[3] !== children) {
    t1 = <div className="vt">{children}</div>;
    $[3] = children;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== ctx || $[6] !== t1) {
    t2 = <ActionsContext.Provider value={ctx}>{t1}</ActionsContext.Provider>;
    $[5] = ctx;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}